export const path = {
  withAuth: {
    referral: '/referral',
    profile: '/profile'
  },
  public: {
    home: '/',
    game: '/game',
    dashboard: '/dashboard',
    marketplace: '/marketplace',
    districts: '/districts',
    story: '/story'
  }
};
